const toggleSelected = (prevState, { treeId, nodeId, adapter, plugins }) => {
  const treeState = prevState[treeId];
  if (!treeState) {
    return;
  }

  const { selection, highlighting } = plugins;
  if (highlighting) {
    highlighting.setHighlighting(treeState, null, { adapter });
  }
  if (!selection) {
    return prevState;
  }

  return {
    ...prevState,
    [treeId]: selection.toggleNodeSelected(treeState, nodeId, { adapter }),
  };
};
export default toggleSelected;
